import jquery from 'jquery'
import Hammer from 'hammerjs'
import _ from 'lodash'
import Planboard from './planboard/Planboard.js'
;(function($) {
  var $planboard = $('#planboard')
  if ($planboard.length <= 0) {
    return
  }

  /* Variables */

  // Cache some variables

  var $workspace = $planboard.find('#planboard-workspace'),
    $filter = $planboard.find('#planboard-filter form'),
    $planboardActivities = $planboard.find('.planboard__activities')

  // Add total existing rows in package selector to form
  // Add deal count to form
  $('body').on('modal.content', function(e) {
    var $choosePackageForm = $(e.modal).find(
      '[data-planboard-action="choosepackage"]',
    )

    if ($choosePackageForm.length) {
      const $activeSelector = $('.planboard__package-selector.active')

      if ($activeSelector.length) {
        var $rows = $activeSelector.find('.planboard-package-product'),
          highestDealCount = 0,
          count = $rows.length ? $rows.length : 0

        var dealCounts = $activeSelector
          .find('[data-deal]')
          .map(function() {
            return parseInt($(this).attr('data-deal'), 10)
          })
          .get()

        if (dealCounts.length) {
          highestDealCount = Math.max.apply(Math, dealCounts)
        }

        $('<input type="hidden" name="count" value="' + count + '">').appendTo(
          $choosePackageForm,
        )
        $(
          '<input type="hidden" name="deal" value="' + highestDealCount + '">',
        ).appendTo($choosePackageForm)
      }
    }
  })

  // Pointer
  const $pointer = $planboard.find('#planboard-pointer')
  const $pointerLabel = $pointer.find('.planboard__pointer-label')

  // Position and show pointer
  $planboard.hoverIntent(
    function(e) {
      var $slot = $(this)

      $pointerLabel
        .css({ top: $slot.parents('.planboard__activity').position().top + 82 })
        .text($slot.attr('data-start-time') + ' ' + $slot.attr('data-type'))

      if ($planboardActivities.width() - 150 < $slot.position().left + 76) {
        $pointerLabel.addClass('planboard__pointer-label--flipped')
      } else {
        $pointerLabel.removeClass('planboard__pointer-label--flipped')
      }

      $pointer.css({ left: $slot.position().left + 76 }).show()
    },
    function(e) {},
    '.planboard-slot',
  )

  $filter.on('change', function(e) {
    if ($(e.target).data('auto-submit')) {
      $filter.submit()
    }
  })

  var hammertime = new Hammer($workspace[0], {
    threshold: 0,
    direction: Hammer.DIRECTION_HORIZONTAL,
  })

  hammertime
    .on('panleft panright', function(e) {
      $workspace.stop(true).addClass('panning')

      if (e.type == 'panleft') {
        $workspace.scrollLeft($workspace.scrollLeft() + 15)
      }

      if (e.type == 'panright') {
        $workspace.scrollLeft($workspace.scrollLeft() - 15)
      }

      if (e.isFinal) {
        var absVelo = Math.abs(e.velocityX),
          ratio = (100 - absVelo * 10) / 100,
          timing = Math.floor(800 / (absVelo * ratio)),
          amount = Math.floor(100 * e.velocityX)

        if (absVelo > 1) {
          $workspace.animate(
            { scrollLeft: '-=' + amount },
            timing,
            'easeOutQuad',
          )
        }
      }
    })
    .on('panend', function(e) {
      $workspace.removeClass('panning')
    })

  var $labels = $('.planboard__activity-label')

  $workspace.on(
    'scroll',
    _.debounce(function(e) {
      $labels.css({
        transform: 'translateX(' + $workspace.scrollLeft() + 'px)',
      })
    }, 100),
  )

  $(function() {
    new Planboard($planboard)
  })
})(jquery)
